if (!customElements.get('cpa-conversion-gallery')) {
  customElements.define('cpa-conversion-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-cg-track]');
      this.slides = Array.from(this.querySelectorAll('[data-cg-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-cg-thumb]'));
      this.previous = this.querySelector('[data-cg-previous]');
      this.next = this.querySelector('[data-cg-next]');
      this.status = this.querySelector('[data-cg-status]');
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.activeIndex = 0;
      this.querySelectorAll('[data-cg-controls]').forEach(control => { control.hidden = false; });
      this.setAttribute('data-cg-ready', '');
      this.previous?.addEventListener('click', () => this.show(this.activeIndex - 1), options);
      this.next?.addEventListener('click', () => this.show(this.activeIndex + 1), options);
      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => this.show(index), options);
      });
      this.track.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        let index;
        if (event.key === 'ArrowLeft') index = this.activeIndex - 1;
        if (event.key === 'ArrowRight') index = this.activeIndex + 1;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.show(index);
      }, options);
      this.track.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 120);
      }, { ...options, passive: true });
      this.track.addEventListener('scrollend', () => this.syncFromScroll(), options);
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (!width || width === this.previousWidth) return;
        this.previousWidth = width;
        this.show(this.activeIndex, false);
      });
      this.resizeObserver.observe(this.track);
      this.update(0);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      window.clearTimeout(this.scrollTimer);
      this.controller = null;
    }

    show(index, animate = true) {
      const boundedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left = this.slides[boundedIndex].offsetLeft - this.slides[0].offsetLeft;
      this.update(boundedIndex);
      this.track.scrollTo({ left, behavior: animate && !reduceMotion ? 'smooth' : 'instant' });
    }

    syncFromScroll() {
      const trackLeft = this.track.getBoundingClientRect().left;
      let nearestIndex = 0;
      let nearestDistance = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < nearestDistance) {
          nearestIndex = index;
          nearestDistance = distance;
        }
      });
      this.update(nearestIndex);
    }

    update(index) {
      this.activeIndex = index;
      if (this.previous) this.previous.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.slides.length - 1;
      if (this.status) this.status.textContent = `${index + 1} / ${this.slides.length}`;
      this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
        if (thumbnailIndex === index) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
    }
  });
}
